import { render, staticRenderFns } from "./SpecialDataTableMenu.vue?vue&type=template&id=ecd345ce&scoped=true&"
import script from "./SpecialDataTableMenu.vue?vue&type=script&lang=js&"
export * from "./SpecialDataTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd345ce",
  null
  
)

export default component.exports